import { createElement, Fragment, type FC, type JSX } from "react";
import { type Poll } from "~/lib/db/poll";
import {
  createHtmlAudioVimeoBlock,
  createHtmlVideoYoutube,
  type PostContentBlocksType,
} from "~/utils/postUtils";
import PollBlock from "./Blocks/PollBlock";
import SocialComponent from "./Blocks/SocialBlock";
import { getStyleFromBlocks } from "~/utils/extractBlocksData";
import { type Element } from "domhandler";
import parse from "html-react-parser";
import MediaTextComponent from "./Blocks/MediaTextBlock";
import FormEsperienza from "./Blocks/FormEsperienza";
type BlocksProps = {
  blocks: PostContentBlocksType[];
  polls: Poll[];
  idBlock: number;
  father: PostContentBlocksType;
  indexArticle: number;
};
interface props {
  className: string;
}
const Blocks: FC<BlocksProps> = ({
  blocks,
  polls = [],
  idBlock = 0,
  father = null,
  indexArticle = 0,
}) => {
  let childrenCountBlocks = 0;
  return blocks.map((block, index) => {
    if (block.innerHTML.includes("poll id")) {
      return <PollBlock key={index} block={block} polls={polls} />;
    }
    switch (block.blockName) {
      case "core/social-links":
        return <SocialComponent key={index} block={block} />;
      case "core/media-text":
        return (
          <MediaTextComponent
            block={block}
            polls={[]}
            idBlock={index}
            indexArticle={indexArticle}
          />
        );
      default: {
        if (block.blockName == "core/embed") {
          if (block.innerHTML.includes("youtube"))
            return (
              <div
                className={`wp-block-${indexArticle}-${idBlock++}`}
                dangerouslySetInnerHTML={{
                  __html: createHtmlVideoYoutube(block.innerHTML),
                }}
              ></div>
            );
          if (block.innerHTML.includes("vimeo"))
            return (
              <div
                className={`wp-block-${indexArticle}-${idBlock++}`}
                dangerouslySetInnerHTML={{
                  __html: createHtmlAudioVimeoBlock(
                    block.innerHTML,
                    block.attrs
                  ),
                }}
              ></div>
            );
        }
        if (block.blockName == "contact-form-7/contact-form-selector") {
          return <FormEsperienza key={index} attrs={block.attrs} />;
        }
        if (block.innerHTML != `\n\n` && father == null) idBlock++;
        if (father != null) childrenCountBlocks++;
        const blocksStyle = getStyleFromBlocks(
          [block],
          idBlock,
          father != null ? childrenCountBlocks : 0,
          indexArticle
        );
        if (!block.innerBlocks || block.innerBlocks.length === 0) {
          return (
            <Fragment key={index}>
              {blocksStyle != null && father != null && (
                <style
                  dangerouslySetInnerHTML={{ __html: blocksStyle }}
                ></style>
              )}
              {parse(block.innerContent.join(""), {
                replace(domNode: Element, index) {
                  if (domNode?.attribs && domNode?.parent === null)
                    if (domNode?.attribs?.class) {
                      domNode!.attribs!.class += ` wp-block-${indexArticle}-${idBlock}-${
                        father != null ? childrenCountBlocks : 0
                      }`;
                    } else {
                      domNode!.attribs!.class = `wp-block-${indexArticle}-${idBlock}-${
                        father != null ? childrenCountBlocks : 0
                      }`;
                    }
                },
              })}
            </Fragment>
          );
        }

        const blockReactElement = parse(block.innerContent.join(""), {
          library: {
            createElement: (type, props: props) => {
              const children = (
                <Blocks
                  blocks={block.innerBlocks}
                  polls={polls}
                  idBlock={idBlock}
                  father={block}
                  indexArticle={indexArticle}
                />
              );
              if (!props?.className) props!.className = "";
              props!.className += ` ${
                block?.attrs?.layout?.type == "flex" ? "is-layout-flex" : ""
              } wp-block-${indexArticle}-${idBlock}-${
                father != null ? childrenCountBlocks : 0
              }`;
              return createElement(type, props, children);
            },
            cloneElement: function (
              element: JSX.Element,
              props?: object,
              ...children: any[]
            ): JSX.Element {
              throw new Error("Function not implemented.");
            },
            isValidElement: function (element: any): boolean {
              throw new Error("Function not implemented.");
            },
          },
        });

        return (
          <Fragment key={index}>
            {blocksStyle != null && (
              <style dangerouslySetInnerHTML={{ __html: blocksStyle }}></style>
            )}
            {blockReactElement}
          </Fragment>
        );
      }
    }
  });
};
export default Blocks;
